export const Page = styled.div`
  position: relative;
  height: auto;
  max-width: 1872px;
  margin-top: 48px;
  margin-bottom: 48px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 12vw;
  padding-right: 12vw;
`;

export const PageHeading = styled.h1`
  font-weight: 800;
  font-size: 26px;
  line-height: 48px;
  color: #171717;
  margin-bottom: 10px !important;
  margin-top: 0;

  &&& {
    margin-bottom: 10px !important;
  }
`;

export const PageSubHeading = styled.div`
  font-weight: 400;
  color: #171717;
  font-size: 14px;
  line-height: 25px;
  white-space: pre-wrap;
`;

export const PageTitle = styled.div`
  font-weight: 500;
  font-size: 22px;
  line-height: 48px;
  color: #171717;
  margin-top: 40px;
  margin-bottom: 20px;
`;

export const PageContainer = styled.div`
  margin: auto;
  height: auto;
  max-width: 1332px;
`;

export const HomeLettersContainer = styled.div`
  margin: auto;
  background-color: #ffffff;
  position: relative;
  height: auto;
  min-height: 20px;
  max-width: 1332px;
  box-shadow: 0 2px 7px rgb(0 0 0 / 0.2);
`;

export const LetterTypeContainer = styled.div`
  min-height: 84px;
  padding: 20px;
  border-width: 0 0 1px 0;
  border: 1px solid #e5e5e5;
  white-space: pre-wrap;
  color: #171717;

  &:hover {
    background-color: #ebebeb;
    cursor: pointer;
  }
`;

export const LetterTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LetterTypeTitleContainer = styled.div`
  width: 98%;
`;

export const LetterTypeTitle = styled.p`
  font-weight: 600;
`;

export const LetterTypeDescription = styled.p`
  font-weight: 400;
  padding-top: 5px;
  width: 90%;
`;

export const LetterChevron = styled.img``;

export const ErrorLoadingTemplates = styled.img`
  width: 215px;
  height: 175px;
  margin-bottom: 10px;
`;

export const HomeStatusContainer = styled.div`
  display: flex;
  flex-direction: column !important;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
`;
